import React from "react";

export default function Chip(props) {
  var styles = {
    good: { borderColor: "rgba(107,143,113,.3)", color: "#6b8f71", background: "rgba(107,143,113,.08)" },
    warn: { borderColor: "rgba(201,150,58,.3)", color: "#a07828", background: "rgba(201,150,58,.08)" },
    bad:  { borderColor: "rgba(184,92,56,.3)",  color: "#b85c38", background: "rgba(184,92,56,.08)" },
  };
  var st = styles[props.type] || styles.warn;
  return <span style={{ fontSize: 10, letterSpacing: ".8px", padding: "4px 11px", borderRadius: 100, border: "1px solid", ...st }}>{props.label}</span>;
}
